import React, { Component } from 'react';
import { registerVendor, getCatDrop } from '../../API/FetchCall';
import $ from 'jquery';
import FetchCall from '../../API/FetchCall';
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

import Geocode from "react-geocode";
Geocode.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
Geocode.setLanguage("en");
Geocode.setRegion("es");
Geocode.enableDebug();
class Register extends Component {

    constructor(props) {
        super(props);

        const queryString = require('query-string');
        let parsed = queryString.parse(props.location.search);


        this.state = {
            url_parsed: parsed.partner != undefined ? parsed.partner : 0,
            register_step1: true,
            register_step2: false,
            paymentMode: '',
            organisation_name: '',
            user_type: '1',
            user_name: '',
            organisation_register_number: '',
            email_id: '',
            phone_number: '',
            organisation_type: '',
            state: '',
            location: '',
            pin_code: '',
            address: '',
            password: '',
            cpassword: '',
            cheque_image: '',
            package_type: '',
            payment_mode: '1',
            errors: [],
            address2: 'Test',
            org_type_list: [],
            social_media_link: '',
            is_org: false,
            is_owner: false,
            incharge_name: '',
            incharge_text: 'In-Charge ',
            social_link: 'lnkin',
            socialPlace: 'LinkedIn',
            agree: false,
            designation: '',
            cateList: [],
            autoSuggCate: []
        }
        this.orgList();
        this.cateList();
        // $('.selectpicker').selectpicker('refresh');
    }
    async cateList() {
        getCatDrop(0).then((res) => {
            if (res.status === 1) {
                var list = res.results;
                list.map((item, i) => {
                    item.options = item.options.flat(Infinity);
                })
                let fiArr = [];
                list.map((item, i) => {
                    fiArr.push(item.options);
                })
                fiArr = fiArr.flat(Infinity);
                this.setState({
                    cateList: res.results,
                    autoSuggCate: fiArr,
                });
            }
        });


    }
    getSelect = () => {

        let rows = '';
        {
            rows = this.state.cateList.length > 0 &&
                this.state.cateList.map((item, i) => {
                    return (
                        <option value={item.category_id} data-tokens={item.options.toString()}>{item.label}</option>
                    )
                })
        }

        return rows;

    }
    showValidationErr(elm, msg) {
        this.setState((prevState) => ({ errors: [...prevState.errors, { elm, msg }] }));
    }
    clearValidationErr(elm) {
        this.setState((prevState) => {
            let newArr = [];
            for (let err of this.state.errors) {
                if (elm !== err.elm) {
                    newArr.push(err);
                }
            }
            return { errors: newArr };
        })

    }
    componentDidUpdate() {
        window.jQuery('.selectpicker').selectpicker('refresh');
    }
    componentDidMount() {

        if (this.state.url_parsed === 'individual') {
            this.setState({
                user_type: '1',
            })
        } else if (this.state.url_parsed === 'institutional') {
            this.setState({
                user_type: '2',
                is_org: true,
            })
        }
    }
    componentWillMount() {
    }

    async orgList() {
        let response = await FetchCall.getSubCategory('0');
        console.log('boeList', response);
        if (response) {
            this.setState({ org_type_list: response.results });
        }
    }
    handleChange = (e) => {
        const propName = e.target.name;
        this.setState({ [e.target.name]: e.target.value });
        if (e.target.value !== '') {
            this.clearValidationErr(propName);
        }
        if (propName === 'user_type' && e.target.value === '1') {
            this.clearValidationErr('organisation_register_number');
        }

        if (propName === 'user_type' && e.target.value === '2') {
            this.setState({
                is_org: true,
                is_owner: false
            });
        } else if (propName === 'user_type' && e.target.value === '1') {
            this.setState({
                is_org: false,
                is_owner: false,
                incharge_text: 'In-Charge',
                designation: '',
                incharge_name: ''
            });
        }

    };

    handleClick = (e) => {
        console.log(e.target.name)
        const propName = e.target.name;
        this.setState(prevState => ({
            [propName]: !prevState[propName]
        }));
        console.log('sad', e.target.value)
        if (propName === 'is_owner' && e.target.value === 'false') {
            this.setState({
                incharge_text: '',
                designation: ''
            })
        } else if (propName === 'is_owner' && e.target.value === 'true') {
            this.setState({
                incharge_text: 'In-Charge ',
            })
        }
    }

    handleSelect = (e) => {
        const propName = e.target.name;
        const value = [...e.target.selectedOptions].map((item) => item.value);
        this.setState({ [propName]: value });
        this.clearValidationErr(propName);
        console.log('va', value)
        if (propName === 'social_link' && value[0] === 'fb') {
            this.setState({
                socialPlace: 'Facebook'
            })
        } else if (propName === 'social_link' && value[0] === 'twt') {
            this.setState({
                socialPlace: 'Twitter'
            })
        } else if (propName === 'social_link' && value[0] === 'lnkin') {
            this.setState({
                socialPlace: 'LinkedIn'
            })
        } else if (propName === 'social_link' && value[0] === 'insta') {
            this.setState({
                socialPlace: 'Instagram'
            })
        }
    };
    handleplaceChange = address => {
        this.setState({ address, pin_code: '', state: '', location: '' });

    };

    handleplaceSelect = address => {
        this.setState({ address: address });
        // this.Geocode_location();
        Geocode.fromAddress(address).then(
            response => {

                console.log('responsexxxx', response.results[0].address_components);

                var geolen = response.results[0].address_components.length;
                var pincode = '';
                var state = '';
                var city = '';
                for (let i = 0; i < geolen; i++) {

                    if (response.results[0].address_components[i].types[0] == "postal_code") {
                        pincode = response.results[0].address_components[i].short_name;
                    }
                    if (response.results[0].address_components[i].types[0] == "administrative_area_level_1") {
                        state = response.results[0].address_components[i].long_name;
                    }
                    if (response.results[0].address_components[i].types[0] == "administrative_area_level_2") {
                        city = response.results[0].address_components[i].long_name;
                    }

                }

                console.log('pincode', pincode)
                console.log('state', state)
                console.log('city', city)
                this.get_location(pincode, state, city);
            },
            error => {
                console.error(error);
            }
        );
    };


    Geocode_location() {
        Geocode.fromAddress(this.state.address).then(
            response => {

                console.log('responsexxxx', response.results[0].address_components);

                var geolen = response.results[0].address_components.length;
                var pincode = '';
                var state = '';
                var city = '';
                for (let i = 0; i < geolen; i++) {

                    if (response.results[0].address_components[i].types[0] == "postal_code") {
                        pincode = response.results[0].address_components[i].short_name;
                    }
                    if (response.results[0].address_components[i].types[0] == "administrative_area_level_1") {
                        state = response.results[0].address_components[i].long_name;
                    }
                    if (response.results[0].address_components[i].types[0] == "administrative_area_level_2") {
                        city = response.results[0].address_components[i].long_name;
                    }

                }

                console.log('pincode', pincode)
                console.log('state', state)
                console.log('city', city)
                this.get_location(pincode, state, city);
            },
            error => {
                console.error(error);
            }
        );

    }


    get_location(pincode, state, city) {
        console.log(pincode, state, city);
        this.setState({
            pin_code: pincode,
            state: state,
            location: city,
        });
    }

    handleSubmitFirst = (e) => {
        e.preventDefault();
        if (this.state.password !== this.state.cpassword) {
            this.showValidationErr("cpassword", "New Password and Confirm password Should Match");
            return false;
        }
        if ((this.state.user_type !== '')
            && (this.state.organisation_type !== '') && (this.state.email_id !== '') && (this.state.state !== '') && (this.state.location !== '') && (this.state.pin_code !== '')
            && (this.state.address !== '') && (this.state.password !== '')) {
            let socialArr = [{
                [this.state.social_link]: this.state.social_media_link
            }]
            
            let ins = '';
            if (this.state.user_type == '1') {
                 ins = JSON.stringify({
                    user_name: this.state.user_name,
                    user_type: this.state.user_type,
                    is_owner: this.state.is_owner,
                    in_charge: this.state.incharge,
                    designation: this.state.designation,
                    organisation_name: '',
                    business_reg_no: '',
                    business_type: this.state.organisation_type,
                    email_id: this.state.email_id,
                    phone_number: this.state.phone_number,
                    state: this.state.state,
                    location: this.state.location,
                    pin_code: this.state.pin_code,
                    address: this.state.address,
                    address2: this.state.address2,
                    password: this.state.password,
                    cpassword: this.state.cpassword,
                    social_media_link: socialArr,
                    agree: this.state.agree
                })
            } else {
                 ins = JSON.stringify({
                    user_name: this.state.user_name,
                    user_type: this.state.user_type,
                    is_owner: this.state.is_owner,
                    in_charge: this.state.incharge,
                    designation: this.state.designation,
                    organisation_name: this.state.organisation_name,
                    business_reg_no: this.state.organisation_register_number,
                    business_type: this.state.organisation_type,
                    email_id: this.state.email_id,
                    phone_number: this.state.phone_number,
                    state: this.state.state,
                    location: this.state.location,
                    pin_code: this.state.pin_code,
                    address: this.state.address,
                    address2: this.state.address2,
                    password: this.state.password,
                    cpassword: this.state.cpassword,
                    social_media_link: socialArr,
                    agree: this.state.agree
                })
            }
            registerVendor(ins).then((res) => {
                let toastr = '';
                if (res.status === 1) {
                    toastr = window.toastr.success;
                    toastr('', 'Your Activation link  has been sent your to registered email id please click the link to activate your account.', {
                        positionClass: "toast-bottom-right",
                        containerId: "toast-bottom-right"
                    });
                    setTimeout(function () {
                        window.location.reload('/');
                      }, 2000);
                } else {
                    let er = res.errors[0].msg
                    toastr = window.toastr.error; //warning
                    toastr(er, toastr, {
                        positionClass: "toast-bottom-right",
                        containerId: "toast-bottom-right"
                    });
                }
            });

        } else {
            console.log('errors', this.state.errors)
            if (this.state.user_type == "") {
                this.showValidationErr("user_type", "Select User Type");
            }
            // if (this.state.organisation_name == "") {
            //     this.showValidationErr("organisation_name", "Enter Organisation name");
            // }
            if (this.state.organisation_register_number == "" && this.state.user_type != '1') {
                this.showValidationErr("organisation_register_number", "Enter Organisation Register Number");
            }

            if (this.state.organisation_type == "") {
                this.showValidationErr("organisation_type", "Select Organisation Type");
            }
            if (this.state.email_id == "") {
                this.showValidationErr("email_id", "Enter Email id");
            }
            if (this.state.state == "") {
                this.showValidationErr("state", "Enter Select State");
            }
            if (this.state.address == "") {
                this.showValidationErr("address", "Enter Enter Address");
            }
            if (this.state.location == "") {
                this.showValidationErr("location", "Enter Select Location");
            }
            if (this.state.pin_code == "") {
                this.showValidationErr("pin_code", "Enter Enter Pincode");
            }
            if (this.state.address == "") {
                this.showValidationErr("user_statetype", "Enter Enter Address");
            }

        }

    }
    handlePaymentMode = (e) => {
        this.setState({
            paymentMode: e.target.value
        })
    }

    handleFile = (e) => {
        this.setState({ [e.target.name]: e.target.files[0] });
        this.clearValidationErr(e.target.name);
    };

    getRender = (params) => {

        return (<TextField
            {...params}
            variant="outlined"
            placeholder="Type Category Here"
        />);
    }
    onTagsChange = (event, values) => {

        let list = this.state.cateList;
        list.map((item, i) => {
            item.options = item.options.flat(Infinity);
        });
        var finalArr = [];
        list.map((item, i) => {
            let intersection = item.options.filter(x => values.includes(x));
            if (intersection.length > 0) {
                finalArr.push(item.category_id)
            }
        });

        this.setState({
            organisation_type: finalArr
        })

    }

    render() {
        console.log('registerVendor', this.state.errors)
        let organisation_nameErr = '';
        let user_typeErr = '';
        let organisation_register_numberErr = '';
        let organisation_typeErr = '';
        let email_idErr = '';
        let phone_numberErr = '';
        let stateErr = '';
        let locationErr = '';
        let pin_codeErr = '';
        let addressErr = '';
        let passwordErr = '';
        let cpasswordErr = '';
        let linkErr = '';
        for (let err of this.state.errors) {
            if (err.elm == 'user_type') {
                user_typeErr = err.msg;
            }
            if (err.elm == 'organisation_name') {
                organisation_nameErr = err.msg;
            }
            if (err.elm == 'organisation_register_number') {
                organisation_register_numberErr = err.msg;
            }
            if (err.elm == 'organisation_type') {
                organisation_typeErr = err.msg;
            }
            if (err.elm == 'email_id') {
                email_idErr = err.msg;
            }
            if (err.elm == 'state') {
                stateErr = err.msg;
            }
            if (err.elm == 'location') {
                locationErr = err.msg;
            }
            if (err.elm == 'pin_code') {
                pin_codeErr = err.msg;
            }
            if (err.elm == 'address') {
                addressErr = err.msg;
            }
            if (err.elm == 'password') {
                passwordErr = err.msg;
            }
            if (err.elm == 'cpassword') {
                cpasswordErr = err.msg;
            }

        }
        console.log('errror', this.state.errors)
        return (
            <React.Fragment>
                <div className="container-fluid">
                    <div className="row dflex">
                        {/* RegisterLeft Starts here */}
                        <div className="col-md-4 col-sm-4  login-left register-left-1 hidden-sm hidden-xs">
                            <h1>Sign up</h1>
                            <div className="img-wrap"></div>
                        </div>
                        <div className="col-md-8 col-sm-8 register-right">
                            <div className="register-form col-md-12 col-xs-12">
                                <div className="nav-brand text-center visible-xs">
                                </div>
                                <div className="formstep-enclose step-1 col-md-12 col-xs-12 pad-no">
                                    {(this.state.register_step1 === true) ? (
                                        <div className="form-step1 col-md-12 col-xs-12 pad-no">
                                            <form onSubmit={this.handleSubmitFirst} className="custom-form">
                                                <div className="row select-register">
                                                    <div className="form-group col-md-12">
                                                        <label>User Type<span className="astrick">*</span></label><br />
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="d-inline-flex mr-10">
                                                                    {this.state.user_type == '1' ?
                                                                        <span>
                                                                            <label><input type="radio" name="user_type" checked={this.state.user_type === '1'} value='1' onChange={this.handleChange} /> Individual</label> &nbsp;&nbsp;&nbsp;
                                                                       </span>
                                                                        :
                                                                        <span>
                                                                            <label><input type="radio" name="user_type" checked={this.state.user_type === '2'} value='2' onChange={this.handleChange} /> Organisation </label> &nbsp;&nbsp;
                                                                        </span>

                                                                    }
                                                                </div>
                                                                {this.state.is_org && (
                                                                    <div className="d-inline-flex">
                                                                        <label><input type="checkbox" name="is_owner" value={this.state.is_owner} onChange={this.handleClick} /> Is this Organisation Owner</label>
                                                                        <small className="alert-msg text-danger"> {user_typeErr}</small>
                                                                    </div>
                                                                )}

                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                                {this.state.is_org && (
                                                    <div className="row">
                                                        <div className="form-group col-md-4">
                                                            <label>{this.state.incharge_text} Name<span className="astrick">*</span></label>
                                                            <input type="text" name="incharge" value={this.state.incharge}
                                                                onChange={this.handleChange} className="form-control" />
                                                        </div>
                                                        {!this.state.is_owner && (
                                                            <div className="form-group col-md-4">
                                                                <label>Designation<span className="astrick">*</span></label>
                                                                <input type="text" name="designation" value={this.state.designation}
                                                                    onChange={this.handleChange} className="form-control" />
                                                            </div>
                                                        )}

                                                    </div>
                                                )}


                                                <div className="row">
                                                    <div className="form-group col-md-4">
                                                        <label>User Name<span className="astrick">*</span></label>
                                                        <input type="text" name="user_name" value={this.state.user_name}
                                                            onChange={this.handleChange} className="form-control" />
                                                    </div>
                                                    {this.state.user_type == '2' ?
                                                        <div>
                                                            <div className="form-group col-md-4">
                                                                <label>Organisation Name<span className="astrick">*</span></label>
                                                                <input type="text" name="organisation_name" value={this.state.organisation_name}
                                                                    onChange={this.handleChange} className="form-control" />
                                                                <small className="alert-msg text-danger"> {organisation_nameErr}</small>
                                                            </div>

                                                            <div className="form-group col-md-4">
                                                                <label>Business Register Number
                                                            {this.state.user_type != '1' ?
                                                                        (<span className="astrick">*</span>) : ''
                                                                    }
                                                                </label>
                                                                <input type="text" name="organisation_register_number" value={this.state.organisation_register_number}
                                                                    onChange={this.handleChange} className="form-control" />
                                                                <small className="alert-msg text-danger"> {organisation_register_numberErr}</small>
                                                            </div>
                                                        </div>
                                                        : ''}
                                                </div>
                                                <div className="row">
                                                    {/* <div className="form-group col-md-6">
                                                        <label>Business Register Number <span className="astrick">*</span></label>
                                                        <input type="text" name="organisation_register_number" value={this.state.organisation_register_number}
                                                            onChange={this.handleChange} className="form-control" />
                                                        <small className="alert-msg text-danger"> {organisation_register_numberErr}</small>
                                                    </div> */}
                                                    <div className="form-group col-md-4">
                                                        <label>E-Mail Id<span className="astrick">*</span></label>
                                                        <input type="email" name="email_id" value={this.state.email_id}
                                                            onChange={this.handleChange} className="form-control" />
                                                        <small className="alert-msg text-danger"> {email_idErr}</small>
                                                    </div>

                                                    <div className="form-group col-md-4">
                                                        <label>Phone Number</label>
                                                        <input type="number" name="phone_number" value={this.state.phone_number}
                                                            onChange={this.handleChange} className="form-control" />
                                                        <small className="alert-msg text-danger"> {phone_numberErr}</small>
                                                    </div>

                                                    <div className="form-group col-md-4">
                                                        <label>Address Line 1<span className="astrick">*</span></label>
                                                        {/* <input type="text" name="address" className="form-control"
                                                            value={this.state.address}
                                                            onChange={this.handleChange}
                                                        /> */}
                                                        <PlacesAutocomplete
                                                            value={this.state.address}
                                                            className="form-control"
                                                            onChange={this.handleplaceChange}
                                                            onSelect={this.handleplaceSelect}
                                                        >
                                                            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                                <div >
                                                                    <input
                                                                        {...getInputProps({
                                                                            placeholder: 'Search Places ...',
                                                                            className: 'form-control',

                                                                        })}
                                                                        value={this.state.address}
                                                                    />
                                                                    <div className="autocomplete-dropdown-container"
                                                                        style={{ position: "absolute", zIndex: "999" }}>
                                                                        {loading && <div>Loading...</div>}
                                                                        {suggestions.map(suggestion => {
                                                                            const className = suggestion.active
                                                                                ? 'suggestion-item--active'
                                                                                : 'suggestion-item';
                                                                            // inline style for demonstration purpose
                                                                            const style = suggestion.active
                                                                                ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                                                                : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                                                            return (
                                                                                <div
                                                                                    {...getSuggestionItemProps(suggestion, {
                                                                                        className,
                                                                                        style,
                                                                                    })}
                                                                                >
                                                                                    <span>{suggestion.description}</span>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </PlacesAutocomplete>



                                                        <small className="alert-msg text-danger"> {addressErr}</small>
                                                    </div>


                                                </div>

                                                <div className="row">

                                                    <div className="form-group col-md-4">
                                                        <label>State<span className="astrick">*</span></label>
                                                        {/* <select className="select-dropdown selectpicker"
                                                            data-live-search="true" title="Choose..."
                                                            name="state"
                                                            onChange={this.handleSelect}>
                                                            <option value="karnataka">Karnataka</option>
                                                            <option value="telangana">Telangana</option>
                                                            <option value="tamil nadu">Tamil Nadu</option>
                                                            <option value="delhi">Delhi</option>
                                                            <option value="kerala">Kerala</option>
                                                        </select> */}
                                                        <input type="text" name="state_name"
                                                            value={this.state.state}
                                                            onChange={this.handleChange}
                                                            className="form-control" />
                                                        <small className="alert-msg text-danger"> {stateErr}</small>
                                                    </div>

                                                    <div className="form-group col-md-4">
                                                        <label>City<span className="astrick">*</span></label>
                                                        <input type="text" name="location"
                                                            value={this.state.location}
                                                            onChange={this.handleChange}
                                                            className="form-control" />
                                                        <small className="alert-msg text-danger"> {locationErr}</small>
                                                    </div>
                                                    <div className="form-group col-md-4">
                                                        <label>Pincode<span className="astrick">*</span></label>
                                                        <input type="text" name="pin_code" className="form-control"
                                                            value={this.state.pin_code}
                                                            onChange={this.handleChange}
                                                        />
                                                        <small className="alert-msg text-danger"> {pin_codeErr}</small>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    {/* <div className="form-group col-md-4">
                                                        <label>Address Line 2<span className="astrick">*</span></label>
                                                        <input type="text" name="address2" className="form-control"
                                                            value={this.state.address2}
                                                            onChange={this.handleChange}
                                                        />
                                                        <small className="alert-msg text-danger"> {addressErr}</small>
                                                    </div> */}
                                                    <div className="form-group col-md-4">
                                                        <label>Category<span className="astrick">*</span></label>
                                                        <Autocomplete
                                                            multiple
                                                            limitTags={2}
                                                            id="multiple-limit-tags"
                                                            onChange={this.onTagsChange}
                                                            options={this.state.autoSuggCate}
                                                            getOptionLabel={(option) => option}
                                                            filterSelectedOptions
                                                            renderInput={this.getRender}
                                                        />
                                                        <small className="alert-msg text-danger"> {organisation_typeErr}</small>
                                                    </div>
                                                    <div className="form-group col-md-4">
                                                        <label>You will Listed under<span className="astrick">*</span></label>
                                                        <select
                                                            value={this.state.organisation_type}
                                                            multiple
                                                            className="select-dropdown selectpicker"
                                                            data-live-search="true" title="Choose..."
                                                            name="organisation_type"
                                                            onChange={this.handleSelect}>
                                                            {this.getSelect()}
                                                        </select>
                                                        <small className="alert-msg text-danger"> {organisation_typeErr}</small>
                                                    </div>
                                                    <div className="form-group col-md-4">
                                                        <label>Social media </label>

                                                        <select className="select-dropdown selectpicker"
                                                            title="Choose..."
                                                            name="social_link"
                                                            onChange={this.handleSelect}
                                                            value={this.state.social_link}>
                                                            <option value='lnkin'>LinkedIn </option>
                                                            <option value='fb'>Facebook </option>
                                                            <option value='insta'>Instagram </option>
                                                            <option value='twt'>Twitter </option>
                                                        </select>

                                                        {/* <input id="social_media_link" type="text" name="social_media_link"
                                                            value={this.state.social_media_link}
                                                            onChange={this.handleChange}
                                                            className="form-control"
                                                            placeholder='Facbook/ Instagram/ LinkedIn' /> */}
                                                        <small className="alert-msg text-danger"> {linkErr}</small>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="form-group col-md-4">
                                                        <label>Password<span className="astrick">*</span></label>
                                                        {/* <i className="pass-visible" toggle="#password-field">
                                                    <img className="off" src="assets/images/visibility-off.svg" alt="icon" />
                                                    <img className="on" src="assets/images/visibility.svg" alt="icon" />
                                                </i> */}
                                                        <input id="password-field" type="password" name="password"
                                                            value={this.state.password}
                                                            onChange={this.handleChange}
                                                            className="form-control" />
                                                        <small className="alert-msg text-danger"> {passwordErr}</small>
                                                    </div>
                                                    <div className="form-group col-md-4">
                                                        <label>Confirm Password<span className="astrick">*</span></label>
                                                        {/* <i className="pass-visible" toggle="#password-fieldc">
                                                    <img className="off" src="assets/images/visibility-off.svg" alt="icon" />
                                                    <img className="on" src="assets/images/visibility.svg" alt="icon" />
                                                </i> */}
                                                        <input id="password-fieldc" type="password" name="cpassword"
                                                            value={this.state.cpassword}
                                                            onChange={this.handleChange}
                                                            className="form-control" />
                                                        <small className="alert-msg text-danger"> {cpasswordErr}</small>
                                                    </div>
                                                    <div className="form-group col-md-4">
                                                        <label>{this.state.socialPlace} Link </label>
                                                        <input id="social_media_link" type="text" name="social_media_link"
                                                            value={this.state.social_media_link}
                                                            onChange={this.handleChange}
                                                            className="form-control"
                                                            placeholder={this.state.socialPlace} />
                                                        <small className="alert-msg text-danger"> {linkErr}</small>
                                                    </div>

                                                </div>

                                                {/* <form class="form">
    <div class="file-upload-wrapper" data-text="Select your file!">
      <input name="file-upload-field" type="file" class="file-upload-field" value=""/>
    </div>
  </form> */}
                                                <div className="row">
                                                    <div className="col-md-6 col-xs-6 text-left">
                                                        <label><input type="checkbox" className="" name="agree" checked={this.state.agree == true} value={this.state.agree} onClick={this.handleClick} /> I agree to <a href="#" >terms of service and privacy policy</a></label>
                                                    </div>

                                                    <div className="col-md-6 col-xs-6 text-right">
                                                        <button type="submit" className="btn btn-blue btn-rounded next">Register</button>
                                                    </div>
                                                </div>


                                            </form>
                                        </div>
                                    ) : ''}
                                    {(this.state.register_step2 === true) ? (
                                        <div className="form-step2 col-md-12 col-xs-12 pad-no">
                                            <form action="#" className="custom-form">
                                                <div className="form-group col-md-12">
                                                    <label>Our Packages<span className="astrick">*</span></label><br />
                                                    <div className="col-md-4">
                                                        <input type="radio" name="package_type" checked={this.state.package_type === '1'} value="1" />&nbsp;Bronze - INR 2000 / Month
                                                    </div>
                                                    <div className="col-md-4">
                                                        <input type="radio" name="package_type" checked={this.state.package_type === '2'} value="2" />&nbsp;Silver - INR 4500 / Month
                                                    </div>
                                                    <div className="col-md-4">
                                                        <input type="radio" name="package_type" checked={this.state.package_type === '3'} value="3" />&nbsp;Gold - INR 6000 / Month
                                                    </div>
                                                    <div className="col-md-4">
                                                        <input type="radio" name="package_type" checked={this.state.package_type === '4'} value="4" />&nbsp;Platinum - INR 7500 / Month
                                                    </div>
                                                    {/* <select className="select-dropdown selectpicker" title="Choose...">
                                                        <option selected='selected'>Bronze - INR 2000 / Month</option>
                                                        <option>Silver - INR 4500 / Month</option>
                                                        <option>Gold - INR 6000 / Month</option>
                                                        <option>Platinum - INR 7500 / Month</option>
                                                    </select> */}
                                                </div>
                                                <div className="form-group col-md-6">
                                                </div>
                                                <div className="form-group col-md-12 package-bg">
                                                    <div className="col-md-6">
                                                        <ul>
                                                            <li>100 Word Write up with Address on site</li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <ul>
                                                            <li>Control over content </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <ul>
                                                            <li>1 Photograph or premisis </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <ul>
                                                            <li>Visibility of Cust Ratings</li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <ul>
                                                            <li>Number of Visits to site </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <ul>
                                                            <li>Auto access for Content update</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className="form-group col-md-12">
                                                    <label>Payment Mode<span className="astrick">*</span></label><br />
                                                    <div className="col-md-4">
                                                        <input type="radio" name="payment_mode" checked={this.state.payment_mode === '1'} value="1" onChange={this.handleChange} onClick={this.handlePaymentMode} />&nbsp;Online Payments
                                                    </div>
                                                    <div className="col-md-4">
                                                        <input type="radio" name="payment_mode" value="2" checked={this.state.payment_mode === '2'} onChange={this.handleChange} onClick={this.handlePaymentMode} />&nbsp;Cheque Collections
                                                    </div>
                                                </div>
                                                {(this.state.paymentMode === '1') ? (
                                                    <div className="col-md-6 payment-bg">
                                                        <div className="form-group col-md-12 m12">
                                                            <label>Card Holder Name</label> <span id="card-holder-name-info"
                                                                className="info"></span><br />
                                                            <input type="text" id="name" name="name" className="form-control" />
                                                        </div>
                                                        <div className="form-group col-md-12 m12">
                                                            <label>Email</label> <span id="email-info" className="info"></span><br />
                                                            <input type="text" id="email" name="email" className="form-control" />
                                                        </div>
                                                        <div className="form-group col-md-12 m12">
                                                            <label>Card Number</label> <span id="card-number-info"
                                                                className="info"></span><br />
                                                            <input type="text" id="card-number" name="card-number" className="form-control" />
                                                        </div>
                                                        <div className="form-group col-md-12 m12">
                                                            <div className="contact-row column-right">
                                                                <label>Expiry Month / Year</label>
                                                                <span id="userEmail-info" className="info"></span><br />
                                                                <select name="month" id="month" className="form-control" style={{ width: '70px', float: "left" }}>
                                                                    <option value="08">08</option>
                                                                    <option value="09">9</option>
                                                                    <option value="10">10</option>
                                                                    <option value="11">11</option>
                                                                    <option value="12">12</option>
                                                                </select>
                                                                <select name="year" id="year" className="form-control" style={{ width: '120px', marginLeft: '92px' }}>
                                                                    <option value="20">2020</option>
                                                                    <option value="21">2021</option>
                                                                    <option value="22">2022</option>
                                                                    <option value="23">2023</option>
                                                                    <option value="24">2024</option>
                                                                    <option value="25">2025</option>
                                                                    <option value="26">2026</option>
                                                                    <option value="27">2027</option>
                                                                    <option value="28">2028</option>
                                                                    <option value="29">2029</option>
                                                                    <option value="30">2030</option>
                                                                </select>
                                                            </div>
                                                            <div className="contact-row form-group  cvv-box">
                                                                <label>CVC</label> <span id="cvv-info" className="info"></span><br />
                                                                <input type="text" name="cvc" id="cvc" className="form-control cvv-input" />
                                                            </div>
                                                        </div>
                                                        <div>

                                                        </div>
                                                    </div>
                                                ) : ""}
                                                {(this.state.paymentMode === '2') ? (
                                                    <div className="form-group col-md-12">
                                                        <label>Upload Cheque/ Reciept</label>
                                                        <input type="file"
                                                            name="cheque_image"
                                                            onChange={this.handleFile} />
                                                        <small>Note: File format .pdf</small>
                                                    </div>
                                                ) : ""}
                                                <div className="col-md-12 col-xs-12 text-right">
                                                    <button className="btn btn-rounded btn-blue">Submit</button>
                                                </div>
                                            </form>
                                        </div>
                                    ) : ''}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}


export default Register;







// WEBPACK FOOTER //
// ./src/components/Login/register.jsx